import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import { useAuth0 } from "../react-auth0-spa";
import { relative } from 'path';

function Navbar() {
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0();

  const logoutWithRedirect = () =>
    logout({
      returnTo: window.location.origin
    });

  //TODO
  useEffect(() => {
    document.getElementById("homeBtn").addEventListener("click", function () {
      if (window.innerWidth < 910) { document.getElementById('theBurger').click(); }
    });
    document.getElementById("signupBtn").addEventListener("click", function () {
      if (window.innerWidth < 910) { document.getElementById('theBurger').click(); }
    });
    document.getElementById("startBtn").addEventListener("click", function () {
      if (window.innerWidth < 910) { document.getElementById('theBurger').click(); }
    });
  });

  return (
    <header className="header-07 js-scroll-this-box">

      <nav className="nav-02">
        <div className="container container--large">
          <div className="nav-02__box">
            <div className="nav-02__logo"><Link className="nav-02__link" to="/">
              <img className="nav-02__logo_img" src="img/icons/Del.png" alt="Logo" />
            </Link></div>
            <div className="nav-02__links js-menu">
              <ul className="nav-02__list">

                <li id="homeBtn" className="nav-02__item"><Link className="button   button--black-outline  button--empty " to="/">Home</Link>
                </li>
                <li id="signupBtn" className="nav-02__item"><Link className="button   button--black-outline  button--empty " to="/signup">Rider? join the team</Link>
                </li>

                <li id="startBtn" className="nav-02__item"><Link className="button   button--black-outline " to="/main">Get Rider</Link>
                </li>

                <li className="nav-02__item" style={{ marginBottom: 50 }} >
                  {!isAuthenticated && (
                    <Link
                      className="button   button--black-outline  button--empty"
                      onClick={() => loginWithRedirect({})}
                    >
                      Log in
                  </Link>
                  )}
                  {isAuthenticated && (
                    <UncontrolledDropdown>
                      <DropdownMenu>
                        <DropdownItem header>{user.name}</DropdownItem>
                        <DropdownItem
                          onClick={() => logoutWithRedirect()}
                        >
                          <Link to="/" className="button--black-outline  button--empty"> Log
                          out</Link>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}
                </li>
              </ul>

              <div className="nav-02__burger">
                <button id="theBurger" className="burger burger--black js-open-menu" type="button">
                  <div className="burger__box">
                    <div className="burger__inner"></div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Navbar;